let module = {};

/**
 * Module Initialization
 */
module.init = function () {

    let accordions = document.querySelectorAll('.js-accordion');

    //For Each Video player, setup our play/pause events
    accordions.forEach((accordion) => {

        let toggler = accordion.querySelector('.js-accordion-toggler');
        let content = accordion.querySelector('.js-accordion-content');

        toggler.addEventListener('click', () => {
            toggler.classList.toggle('active');
            content.classList.toggle('active');
        });
    });
};

document.addEventListener("DOMContentLoaded", () => {
    module.init();
});
